import React from 'react';
import ImageModal from 'components/ImageModal';
import atsBuilding from 'images/ats-exterior.jpg';

const CompanyHistory = () => (
  <div
    className="section is-medium"
    style={{ background: 'rgba(0,0,0,0.04)' }}
  >
    <div className="container">
      <h3 className="title">History</h3>
      <div className="columns">
        <div className="column is-7">
          <p>
            Autumn of 1964, the United States was enjoying a golden age of peace
            and economic growth following World War II. Aviation, and in
            particular, aerospace, was showing the world that the sky was no
            longer the limit. The Space Race was ramping up, and by this time,
            the United States &amp; The Soviet Union had already sent a
            half-dozen men into space.
            <br />
            <br />
            Meanwhile, in the sunny foothill town of Burbank, California,
            partners Bill Fisch and Deken Jones signed the lease on a 5,000
            square foot building where they planned to build parts for the
            growing aerospace industry. In particular, the duo were determined
            to perfect the manufacturing of glass-to-metal sealed connector
            cartridges&mdash;hermetic seals for a new generation of spacecraft.
            <br />
            <br />
            Unlike other independent machine shops at the time, Accratronics was a
            one-stop-shop, controlling every element of the manufacturing
            process. When an order for a part came in, they would machine the
            body, broach keyways, thread the ends, create carbon molds, hermetically
            seal the part  in their CalAlloy furnace, pressure test it, and finally,
            chemically clean the part. Their goal was to be as self-supporting as
            possible, keeping all manufacturing processes in-house, under the careful
            watch of master craftsmen.
            <br />
            <br />
            By November of that year, their choice to be horizontally integrated
            from the start proved invaluable. Accratronics was approached by an
            engineer from Central Technology Inc., a firm that was desperately
            looking for a shop that could machine a peculiarly&ndash;designed
            connector for NASA's Gemini Space Program&mdash;and he needed
            them in a week. Despite the tall order and short timeframe,
            Accratronics pledged to finish the order in an expedited time frame.
            After successfully completing the production of the parts, and the launch
            of the Gemini, the contract was given.
            <br />
            <br />
            Since its foundation, Accratronics Seals, LLC. has continued to grow
            into a multi-million dollar enterprise, still a family business run
            and managed by founder Deken Jones' children. For over 50 years this
            aerospace one-stop-shop has proudly continued a legacy built upon
            excellent service, high performance, and unwavering trust.
          </p>
        </div>
        <div className="column is-4 is-offset-1">
          <ImageModal
            src={atsBuilding}
            alt="Accratronics"
            caption="Accratronics' Shop in Burbank, California"
          />
        </div>
      </div>
    </div>
  </div>
);

export default CompanyHistory;



// WEBPACK FOOTER //
// ./src/pages/About/components/CompanyHistory.js